import React from 'react';
import PropTypes from 'prop-types';
import {Button, Typography, Dialog, DialogContent, DialogContentText, DialogActions} from '@material-ui/core';
import {ErrorOutline as ErrorOutlineIcon} from '@material-ui/icons';
import {PrimaryButton} from './StyledButtons';

export default class DeletionConfirm extends React.Component {
    static propTypes = {
        componentClass: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.func,
        ]),
        className: PropTypes.string,
        itemName: PropTypes.string,
        alertText: PropTypes.string,
        DeleteButton: PropTypes.oneOfType([
            PropTypes.func,
            PropTypes.string,
        ]).isRequired,
        deleteAction: PropTypes.func.isRequired,
    };
    static defaultProps = {
        componentClass: 'span',
        DeleteButton: 'span',
    };

    constructor(props) {
        super(props);
        this.state = {
            modalOpen: false,
        };
        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.handleModalConfirm = this.handleModalConfirm.bind(this);
    }

    openModal() {
        this.setState({
            modalOpen: true,
        });
    }

    closeModal() {
        this.setState({
            modalOpen: false,
        });
    }

    handleModalConfirm() {
        const {deleteAction} = this.props;
        deleteAction();
        this.closeModal();
    }

    render() {
        const {modalOpen} = this.state;
        const {
            componentClass: RootComponent,
            className,
            itemName,
            alertText,
            DeleteButton,
        } = this.props;
        const text = alertText ? alertText : `Please confirm that you wish to delete ${itemName || 'this item'}`;
        return (
            <RootComponent className={className}>
                <Dialog
                    open={modalOpen}
                    onClose={this.closeModal}
                >
                    <DialogContent>
                        <Typography align="center" color="error" gutterBottom>
                            <ErrorOutlineIcon style={{width: '6rem', height: '6rem'}}/>
                        </Typography>
                        <Typography variant="h5" align="center" color="error" gutterBottom>Are you sure?</Typography>
                        <DialogContentText align="center">{text}</DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.closeModal}>
                            Cancel
                        </Button>
                        <PrimaryButton onClick={this.handleModalConfirm}>
                            Delete
                        </PrimaryButton>
                    </DialogActions>
                </Dialog>
                <DeleteButton onClick={this.openModal} className="btn-show-confirm"/>
            </RootComponent>
        );
    }
}
